import script from "./TagList.vue?vue&type=script&lang=ts&setup=true"
export * from "./TagList.vue?vue&type=script&lang=ts&setup=true"

import "./TagList.vue?vue&type=style&index=0&id=06fa77fc&scoped=true&lang=scss"

import exportComponent from "/github/workspace/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-06fa77fc"]])

export default __exports__